require('normalize.css/normalize.css');
require('styles/font-awesome.css');
import '../fonts/fontawesome-webfont.ttf';
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
require('styles/App.scss');
import * as loginActions from '../actions/loginActionCreators';
import * as runActions from '../actions/runsActionCreators';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as utils from '../utils/utils';
import toastr from 'toastr';
import React from 'react';
import Footer from './common/Footer';
import { Link } from 'react-router';
import { Row, Col } from 'react-bootstrap';

class AppComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleLogout = this.handleLogout.bind(this);
    this.goToProfile = this.goToProfile.bind(this);
    toastr.options = { closeButton: true, progressBar: true, timeOut: '6000' };
  }

  componentWillReceiveProps(nextProps) {
    const { runName } = nextProps.params;
    if (localStorage.getItem('run') != nextProps.params.runName) {
      this.handleLocationChanged(runName, 0);
      this.props.runActions.getRun();
    }
  }

  handleLogout() {
    let runName = localStorage.getItem('run');
    this.props.loginActions.logoutAndRedirect().then(() => {
      browserHistory.push('/administer/' + runName + '/login');
    });
  }

  componentWillMount() {
    const { runName } = this.props.params;
    if (localStorage.getItem('run') != this.props.params.runName) {
      this.handleLocationChanged(runName, 0);
    }
  }

  goToProfile() {
    browserHistory.push('/administer/' + localStorage.getItem('run') + '/profile');
  }

  componentDidMount() {
    this.props.runActions.getRun();
  }

  handleLocationChanged = (runName, role) => {
    localStorage.setItem('run', runName);
    localStorage.setItem('r', role);
  };

  render() {
    let runName = localStorage.getItem('run');
    const { school } = this.props;
    return (
      <div className="container-fluid">
        <div className="branding">
          { (school && school.header_image) ? <img className="schoolLogo" src={school.header_image} /> : <img className="mainLogo" src={utils.getMainLogo()} />}
        </div>
        <Row>
          {localStorage.getItem('auth') ? (
            <Col md={12} className="header-menu">
              <a className="pull-right" href="" onClick={this.handleLogout}>
                Logout
              </a>
              <span className="pull-right mr-1 ml-1"> | </span>
              <Link className="pull-right" to={'/administer/' + runName + '/profile'}>
                <i
                  onClick={() => {
                    this.goToProfile();
                  }}
                  className="fa fa-user-circle pull-right user-avatar"
                />{' '}
                {utils.getUser()}
              </Link>
            </Col>
          ) : (
            ''
          )}
          {this.props.children}
        </Row>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    runName: state.login.runName,
    school: state.school
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);



// WEBPACK FOOTER //
// ./src/components/Main.js